<div class="vsc-grid">
  <div class="vsc-grid__table-section">
  <mc-table
    fit="small"
    [data]="tableData()"
    [columns]="columns"
    nowrap="true"
    headersticky
    height="100%"
    (sortchange)="onSortChange($event)">
    @for (row of tableData(); track row.vendorCode) {
      <div [slot]="row.id + '_vendorCode'">
        <a
          class="vsc-list__vendor-link"
          target="_blank"
          rel="noopener"
          [routerLink]="['/scorecard', row.vendorCode]"
          [queryParams]="linkQueryParams()">{{ row.vendorCode }}</a>
      </div>
      <div [slot]="row.id + '_workOrderCount'" class="vsc-count-cell">{{ countLabel(row.workOrderCount) }}</div>
      <div [slot]="row.id + '_overallScore'" class="vsc-score-cell vsc-score-cell--overall">
        @if (row.overallScore != null) {
          <span class="vsc-score-circle" [ngClass]="'score--' + scoreBand(row.overallScore)">{{ scoreLabel(row.overallScore) }}</span>
        } @else {
          <span class="vsc-score-empty">—</span>
        }
      </div>
      <div [slot]="row.id + '_leadTimeScore'" class="vsc-score-cell">
        @if (row.leadTimeScore != null) {
          <span class="vsc-score-circle" [ngClass]="'score--' + scoreBand(row.leadTimeScore)">{{ scoreLabel(row.leadTimeScore) }}</span>
        } @else {
          <span class="vsc-score-empty">—</span>
        }
      </div>
      <div [slot]="row.id + '_processComplianceScore'" class="vsc-score-cell">
        @if (row.processComplianceScore != null) {
          <span class="vsc-score-circle" [ngClass]="'score--' + scoreBand(row.processComplianceScore)">{{ scoreLabel(row.processComplianceScore) }}</span>
        } @else {
          <span class="vsc-score-empty">—</span>
        }
      </div>
      <div [slot]="row.id + '_eEIRScore'" class="vsc-score-cell">
        @if (row.eEIRScore != null) {
          <span class="vsc-score-circle" [ngClass]="'score--' + scoreBand(row.eEIRScore)">{{ scoreLabel(row.eEIRScore) }}</span>
        } @else {
          <span class="vsc-score-empty">—</span>
        }
      </div>
      <div [slot]="row.id + '_auditResultScore'" class="vsc-score-cell">
        @if (row.auditResultScore != null) {
          <span class="vsc-score-circle" [ngClass]="'score--' + scoreBand(row.auditResultScore)">{{ scoreLabel(row.auditResultScore) }}</span>
        } @else {
          <span class="vsc-score-empty">—</span>
        }
      </div>
    }
  </mc-table>
  </div>

  @if (rows().length > 0) {
    <div class="vsc-grid__footer">
      <mc-select
        fit="small"
        [value]="pageSize()"
        label="Items per page"
        labelposition="left"
        (optionselected)="onPageSizeChange($event)">
        <mc-option [value]="10">10</mc-option>
        <mc-option [value]="20">20</mc-option>
        <mc-option [value]="50">50</mc-option>
        <mc-option [value]="100">100</mc-option>
      </mc-select>

      <mc-pagination
        hiddenlabels
        [currentpage]="currentPage()"
        [totalpages]="totalPages()"
        visiblepages="7"
        fit="small"
        (pagechange)="onPageChange($event)">
      </mc-pagination>

      <span class="mds-text--small-normal mds-neutral--weak__text-color">{{ pageRangeLabel() }}</span>
    </div>
  }
</div>
